// extracted by mini-css-extract-plugin
module.exports = {"artplacer-logo":"LogoAndSearch_artplacer-logo__6kkKg","search-input":"LogoAndSearch_search-input__ySmWm","search-icon":"LogoAndSearch_search-icon__6bzYy"};